import Renderer from "@wielink/datatables/Renderers/Renderer";

class TextRenderer extends Renderer {
	render() {
		return this.data.substring(0, 150);
	}
}

export default TextRenderer;